import { CommonModule } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  Input,
  OnInit,
} from '@angular/core';
import {
  AccurateUnassignedItem,
  ACTIVITY_BORDER_PX,
  ACTIVITY_TITLE_HEIGHT_PX,
  ACTIVITY_TITLE_MARGIN_BOTTOM_PX,
  ACTIVITY_TITLE_MARGIN_TOP_PX,
} from '@wilson/interfaces';
import {
  GanttEndingPixelPipe,
  GanttStartingPixelPipe,
  TimeDifferenceWidthPxPipe,
} from '@wilson/shift-timeline/assignments-gantt-chart';
import { ActivityWithOverlapLevel } from '@wilson/shift-timeline/services';
import { differenceInMilliseconds } from 'date-fns';
import { DateFnsModule } from 'ngx-date-fns';
import { AutoSizeWrapperForDataWithActivitiesComponent } from '../auto-size-wrapper-for-data-with-activities/auto-size-wrapper-for-data-with-activities.component';

@Component({
  selector: 'wilson-unassigned-item-wrapper',
  imports: [
    CommonModule,
    AutoSizeWrapperForDataWithActivitiesComponent,
    DateFnsModule,
    TimeDifferenceWidthPxPipe,
    GanttStartingPixelPipe,
    GanttEndingPixelPipe,
  ],
  templateUrl: './unassigned-item-wrapper.component.html',
  styleUrl: './unassigned-item-wrapper.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UnassignedItemWrapperComponent implements OnInit {
  @Input({
    required: true,
  })
  item!: AccurateUnassignedItem;

  @Input({
    required: true,
  })
  activityWithOverlapLevel!: ActivityWithOverlapLevel[][];

  @Input({
    required: true,
  })
  name!: string;

  @Input()
  isHighlighted = false;

  @Input() parentElement!: HTMLElement | null;

  protected accurateServiceDurationMs!: number;
  public BORDER_SIZE = 4;
  ACTIVITY_BORDER_PX = ACTIVITY_BORDER_PX;
  ACTIVITY_TITLE_HEIGHT_PX = ACTIVITY_TITLE_HEIGHT_PX;
  ACTIVITY_TITLE_MARGIN_TOP_PX = ACTIVITY_TITLE_MARGIN_TOP_PX;
  ACTIVITY_TITLE_MARGIN_BOTTOM_PX = ACTIVITY_TITLE_MARGIN_BOTTOM_PX;

  ngOnInit(): void {
    this.accurateServiceDurationMs = differenceInMilliseconds(
      new Date(this.item.accurateEndDateTime),
      new Date(this.item.accurateStartDateTime),
    );
  }
}
